<script>
/* Mixin for updating URL for searching, sorting, and page changes with tables */

export default {
    name: 'UpdateURL',
    methods: {
        /**
         * Updates the URL accordingly based on the page, sort, and search queries of the table.
         * @param {string} baseURL - Base URL to concatenate query parameters to.
         * @param {Object} params - URL parameters (with field and value to query pairs)
         * @return {string} URL
         *
         * @example
         *
         *      updateURL({
         *          baseURL: 'facilities/1/products/',
         *          params: {
         *              search: 'milk',
         *              ordering: '-name',
         *              page: 3,
         *              }
         *      });
         *
         *      returns 'facilities/1/products/?search=milk&ordering=-name&page=3'
         */
        updateURL({ baseURL, params }) {
            // get fields
            const fields = Object.keys(params);
            // build query string in URL
            const queries = [];
            fields.forEach(field => {
                if (params[field] !== '') {
                    // add query
                    queries.push(`${field}=${params[field]}`);
                }
            });
            let url = baseURL;
            if (queries.length > 0) {
                url += `?${queries.join('&')}`;
            }
            return url;
        }
    }
};
</script>
